import { render, staticRenderFns } from "./PolimixProductionKanban.vue?vue&type=template&id=0e4475e6&"
import script from "./PolimixProductionKanban.vue?vue&type=script&lang=js&"
export * from "./PolimixProductionKanban.vue?vue&type=script&lang=js&"
import style0 from "./PolimixProductionKanban.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports